export { getTenantConfig } from './getTenantConfig'
export { getLayoutsConfig } from './getLayoutConfig'
